import { render, staticRenderFns } from "./article-info.vue?vue&type=template&id=5e51253a&scoped=true&"
import script from "./article-info.vue?vue&type=script&lang=js&"
export * from "./article-info.vue?vue&type=script&lang=js&"
import style0 from "./article-info.vue?vue&type=style&index=0&id=5e51253a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e51253a",
  null
  
)

export default component.exports